import { render, staticRenderFns } from "./product-summary-card-icon.vue?vue&type=template&id=709c6f5b"
import script from "./product-summary-card-icon.vue?vue&type=script&lang=ts"
export * from "./product-summary-card-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports